import React from 'react';
import queryString from 'query-string';
import ArticlesComponent from './Articles';
import articles from './../../../../model/article';
import makesModel from '../../../../model/makes';
import generation from '../../../../model/generation';
import withRouter from '/src/components/misc/withRouter';
import cookie from 'js-cookie';

class ArticlesContainer extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      articles: null,
      makes: null,
      working: false,
      showArchived: false,
      limit: 20,
      offset: 0,
      total: null,
      filter: null,
      sort: undefined
    };

    this.generationsArticles = null;

    this.handleSetOffset = this.handleSetOffset.bind(this);
    this.handleToggleShowArchived = this.handleToggleShowArchived.bind(this);
    this.handleFilterChange = this.handleFilterChange.bind(this);
    this.handleSort = this.handleSort.bind(this);
  }

  componentDidMount() {
    document.title = 'Admin - Artikler';
    let offset = this.state.offset;
    const limit = this.state.limit;
    let filter = this.state.filter;
    let sort = this.state.sort;
    let showArchived = this.state.showArchived;

    const query = queryString.parse(this.props.location.search);
    if (query) {
      if (query.page && query.page > 0) {
        offset = (query.page - 1) * limit;
      }
      if (query.showArchived) {
        showArchived = query.showArchived === 'true';
      }
      if (query.sort) {
        sort = query.sort;
      }
    }

    if (query && query.filter) {
      filter = query.filter;
    } else {
      const cookiefilter = cookie.get('mgMakeFilter');

      if (cookiefilter !== 'null') { // null is string in this case
        filter = cookiefilter;
      }
    }

    Promise.all([
      makesModel.select('fields.name'),
      generation.select('fields.articles')
    ]).then(([makes, generationsArticles]) => {
      this.generationsArticles = generationsArticles.items;
      const makesArray = makes.items.map((m) => ({
        id: m.sys.id,
        name: m.fields.name['nb-NO']
      }));

      this.setState({
        makes: makesArray,
        offset: offset,
        limit: limit,
        showArchived: showArchived,
        filter: filter,
        sort: sort
      }, () => {
        this.fetchArticles(this.state.offset, this.state.limit, this.state.filter, this.state.showArchived, this.state.sort);
      });
    });
  }


  setTabCookie(makeId) {
    const tabLink = makeId;
    const cookieName = 'mgMakeFilter';

    cookie.set(cookieName, tabLink, {path: '/'});
  }

  fetchArticles(offset, limit, filter, showArchived, sort) {
    const params = {};
    if (filter) {
      params.makeId = filter;
    }

    params.includeArchived = showArchived;

    articles.allByParams(0, offset, limit, params, sort).then(([articles, total]) => {
      articles.forEach((art) => {
        art.generations = this.generationsArticles.filter((gen) => {
          if (!gen.fields || !gen.fields.articles) {
            return false;
          }

          const genArts = gen.fields.articles['nb-NO'].map((a) => a.sys.id);
          return genArts.includes(art.id);
        });
      });
      this.setState({
        articles: articles,
        working: false,
        total: total
      });
    });
  }

  handleSort(sortString) {
    this.setState({
      working: true,
      sort: sortString,
      offset: 0
    }, () => {
      this.props.history.replace({
        pathname: '/articles',
        search: queryString.stringify({
          page: 1,
          filter: this.state.filter,
          showArchived: this.state.showArchived,
          sort: sortString
        })
      });

      this.fetchArticles(this.state.offset, this.state.limit, this.state.filter, this.state.showArchived, this.state.sort);
    });
  }

  handleFilterChange(makeId) {
    // Reset paging, so we always start on first page after filtering
    this.setState({
      working: true,
      filter: makeId,
      offset: 0
    }, () => {
      this.props.history.replace({
        pathname: '/articles',
        search: queryString.stringify({
          page: 1,
          filter: makeId,
          showArchived: this.state.showArchived
        })
      });

      this.setTabCookie(makeId);
      this.fetchArticles(this.state.offset, this.state.limit, this.state.filter, this.state.showArchived, this.state.sort);
    });
  }

  handleSetOffset(offset) {
    this.setState({
      working: true,
      offset: offset
    }, () => {
      this.props.history.replace({
        pathname: '/articles',
        search: queryString.stringify({
          page: Math.floor(offset / this.state.limit) + 1,
          filter: this.state.filter,
          showArchived: this.state.showArchived
        })
      });

      this.fetchArticles(this.state.offset, this.state.limit, this.state.filter, this.state.showArchived, this.state.sort);
    });
  }

  handleToggleShowArchived() {
    this.setState((prevState) => {
      return {
        showArchived: !prevState.showArchived,
        working: true,
        offset: 0
      };
    }, () => {
      this.props.history.replace({
        pathname: '/articles',
        search: queryString.stringify({
          page: 1,
          filter: this.state.filter,
          showArchived: this.state.showArchived
        })
      });
      this.fetchArticles(this.state.offset, this.state.limit, this.state.filter, this.state.showArchived, this.state.sort);
    });
  }

  render() {
    return (
      <ArticlesComponent
        articles={this.state.articles}
        makes={this.state.makes}
        working={this.state.working}
        handleToggleShowArchived={this.handleToggleShowArchived}
        showArchived={this.state.showArchived}
        handleFilterChange={this.handleFilterChange}
        total={this.state.total}
        limit={this.state.limit}
        offset={this.state.offset}
        handleSetOffset={this.handleSetOffset}
        handleSort={this.handleSort}
        sort={this.state.sort}
        filter={this.state.filter}
      />
    );
  }
}

ArticlesContainer.defaultProps = {
};

export default withRouter(ArticlesContainer);
